import PropTypes from "prop-types"
import { createContext, useContext, useMemo, useState } from "react"
import { emptyChargeDetail } from "../constants/emptyChargeDetail"
import { useNavigationPrompt } from "@thooks/useBlockNavigation"

const NewEditTemplateCollectionContext = createContext({
    loadingTemplate: false,
    chargeDetail: emptyChargeDetail.data,
    showPrompt: false,
    frecuencyRecurrencyOptions: [],
    hasSavedChanges: false,
    buttonsOptions: [],
    buttonsArrearsOptions: [],
    chargeDebtorsData: {
        dataSource: [],
        columns: [],
    },
    cleanTable: false,
    setCleanTable: () => { },
    setChargeDebtorsData: () => { },
    setButtonsArrearsOptions: () => { },
    setButtonsOptions: () => { },
    setHasUnsavedChanges: () => { },
    setFrecuencyRecurrencyOptions: () => { },
    confirmNavigation: () => { },
    cancelNavigation: () => { },
    setChargeDetail: () => { },
    setLoadingTemplate: () => { },
})

export const NewEditTemplateCollectionProvider = ({ children }) => {

    const [loadingTemplate, setLoadingTemplate] = useState(false)
    const [cleanTable, setCleanTable] = useState(false)
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false) // Por defecgto no hay cambios sin guardar

    const {
        showPrompt,
        confirmNavigation,
        cancelNavigation
        
    } = useNavigationPrompt(hasUnsavedChanges)
    const [chargeDebtorsData, setChargeDebtorsData] = useState({
        dataSource: [],
        columns: [],
    })
    const [chargeDetail, setChargeDetail] = useState(emptyChargeDetail.data)
    const [buttonsOptions, setButtonsOptions] = useState([])
    const [frecuencyRecurrencyOptions, setFrecuencyRecurrencyOptions] = useState([])
    const [buttonsArrearsOptions, setButtonsArrearsOptions] = useState([])

    const value = useMemo(() => ({
        loadingTemplate,
        chargeDetail,
        showPrompt,
        hasUnsavedChanges,
        frecuencyRecurrencyOptions,
        buttonsOptions,
        buttonsArrearsOptions,
        chargeDebtorsData,
        cleanTable,
        setCleanTable,
        setChargeDebtorsData,
        setButtonsArrearsOptions,
        setButtonsOptions,
        setFrecuencyRecurrencyOptions,
        confirmNavigation,
        cancelNavigation,
        setHasUnsavedChanges,
        setChargeDetail,
        setLoadingTemplate,
    }), [
        cleanTable,
        chargeDebtorsData,
        buttonsArrearsOptions,
        buttonsOptions,
        frecuencyRecurrencyOptions,
        loadingTemplate,
        hasUnsavedChanges,
        chargeDetail,
        showPrompt,
        confirmNavigation,
        cancelNavigation,
    ])

    return (
        <NewEditTemplateCollectionContext.Provider value={value}>
            {children}
        </NewEditTemplateCollectionContext.Provider>
    )
}

NewEditTemplateCollectionProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useNewEditTemplateCollectionContext = () => {
    const context = useContext(NewEditTemplateCollectionContext)
    if (!context) {
        throw new Error("useNewEditTemplateCollectionContext must be used within a NewEditTemplateCollectionProvider")
    }
    return context
}